(function () {
  const MIN = 20;
  const MAX = 1000;
  const STEP = 5;
  const RECIPIENT_LABEL_TEXT = "Ik wil dit versturen als cadeau via e-mail.";

  function overrideRecipientLabel() {
    document.querySelectorAll(".recipient-checkbox").forEach((el) => {
      el.textContent = RECIPIENT_LABEL_TEXT;
    });
  }

  function init(root) {
    if (root.dataset.cadeaubonReady === "1") return;
    root.dataset.cadeaubonReady = "1";

    const dataEl = root.querySelector("[data-cadeaubon-variants]");
    if (!dataEl) return;

    let variantIdByAmount = {};
    try {
      variantIdByAmount = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error("[cadeaubon] failed to parse variant map", e);
      return;
    }

    const input = root.querySelector("[data-cadeaubon-amount]");
    const errorEl = root.querySelector("[data-cadeaubon-error]");

    const productForms = Array.from(
      document.querySelectorAll(
        'form[action$="/cart/add"], form[data-type="add-to-cart-form"]'
      )
    );
    const variantIdInputs = productForms.flatMap((f) =>
      Array.from(f.querySelectorAll('input[name="id"]'))
    );

    function clampAndSnap(value) {
      if (!Number.isFinite(value)) return MIN;
      let v = Math.round(value / STEP) * STEP;
      if (v < MIN) v = MIN;
      if (v > MAX) v = MAX;
      return v;
    }

    function setError(msg) {
      if (msg) {
        root.dataset.error = "true";
        if (errorEl) errorEl.textContent = msg;
      } else {
        delete root.dataset.error;
        if (errorEl) errorEl.textContent = "";
      }
    }

    function dispatchVariantChange(variantId, amount) {
      const event = new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          variant: { id: variantId, price: amount * 100, available: true },
        },
      });
      root.dispatchEvent(event);
    }

    function apply(amount, opts) {
      opts = opts || {};
      const clean = clampAndSnap(amount);
      const variantId = variantIdByAmount[String(clean)];
      if (!variantId) {
        setError(`Geen geldig bedrag (€${MIN}–€${MAX}, stappen van €${STEP}).`);
        return;
      }
      setError("");

      if (input && opts.updateInput !== false && Number(input.value) !== clean) {
        input.value = String(clean);
      }

      variantIdInputs.forEach((el) => {
        el.value = String(variantId).replace(
          /^gid:\/\/shopify\/ProductVariant\//,
          ""
        );
      });

      dispatchVariantChange(variantId, clean);
    }

    if (input) {
      input.addEventListener("input", () => {
        const raw = Number(input.value);
        if (!Number.isFinite(raw)) return;
        apply(raw, { updateInput: false });
      });
      input.addEventListener("blur", () => {
        const raw = Number(input.value);
        apply(raw);
      });
    }

    const initial = input ? clampAndSnap(Number(input.value) || MIN) : MIN;
    apply(initial);
  }

  function boot() {
    document
      .querySelectorAll("[data-cadeaubon-picker]")
      .forEach((el) => init(el));
    overrideRecipientLabel();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
